import { Swiper } from './swiper-DSEIACnL.js';
import { P as Pagination } from './pagination-BiRS_VrL.js';
import { A as A11y } from './a11y-CNmE74mL.js';
import { C as Cart } from './cart-eLzX7E8s.js';
import { P as PubSub } from './pubsub-CoPYzvVm.js';
import { p as parseHTML } from './parseHTML-Om2c1Ayj.js';
import './utils-CPPFXbqB.js';
import './create-element-if-not-defined-BweCirD8.js';
import './notyf-DIw0RvBj.js';
import './uniq-D7II7obF.js';

class CartComplementaryProducts extends HTMLElement {
  #unsubscribers = [];
  #loadingOverlay = this.querySelector('.loading-overlay');

  static {
    Cart.sections.push('fetch-cart-complementary-products');
  }

  connectedCallback() {
    this.#unsubscribers.push(
      ...['cart:add', 'cart:change'].map((event) =>
        PubSub.subscribe(event, ({ sections }) => this.#renderSection(sections))
      ),
      PubSub.subscribe('cart:fetch', ({ status }) => this.#handleLoading(status === 'pending'))
    );
    this.initSwiper();
  }

  disconnectedCallback() {
    this.#unsubscribers.forEach((unsubscribe) => unsubscribe());
  }

  initSwiper() {
    new Swiper(this.querySelector('.swiper'), {
      modules: [A11y, Pagination],
      slidesPerView: 1.77,
      spaceBetween: 12,
      pagination: { el: this.querySelector('.swiper-pagination') },
      breakpoints: {
        768: { slidesPerView: 2.5 },
        1024: { slidesPerView: 3 },
        1280: { slidesPerView: 4 },
      },
    });
  }

  #renderSection(sections) {
    const html = parseHTML(sections['fetch-cart-complementary-products']);
    const target = html.querySelector('cart-complementary-products');
    this.replaceWith(target);
  }

  #handleLoading(loading) {
    this.#loadingOverlay.ariaHidden = !loading;
  }
}

customElements.define('cart-complementary-products', CartComplementaryProducts);
